import React from "react";
import { initAOS } from "../helper/initAOS";
import SocialMediaLinks from "./SocialMediaLinks";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import * as constants from "../constants";
import { fetchAPI } from "../helper/fetchAPI";
import CustomImageComponent from "./CustomImageComponent";
import { useCountryPrefix } from "../routes/useCountryPrefix";

const Footer = ({ mainSection, areaSection, recommendedSection, contactSection }) => {

  const { i18n } = useTranslation();
  // let apiUrl = process.env.REACT_APP_API_URL;
  // const [mainSection, setMainPageSection] = useState();
  // const [areaSection, setAreaSection] = useState();
  // const [recommendedSection, setRecommendedSection] = useState();
  // const [contactSection, setContactSection] = useState();




  const language = i18n.language === "en" ? "" : i18n.language || "";
  const countryPrefix = useCountryPrefix();



  React.useEffect(() => {
    initAOS({ duration: 1500 });
  }, []);

  return (
    <footer>
      <div className="container" data-aos="fade-up" data-aos-duration="1500">
        <div className="row align-items-center">
          <div className="col-md-6 footer-logo">
            <a href="#">
              <CustomImageComponent
                src={"/assets/img/footer-logo.svg"}
                alt={"Logo"}
                className={"img-fluid "}
                fetchPriority={"high"}
              />
            </a>
          </div>
          <SocialMediaLinks></SocialMediaLinks>
        </div>
      </div>
      <hr />
      <div className="container" data-aos="fade-up" data-aos-duration="1500">
        <div className="row">
          <div className="col-md-6 col-lg-3 mb-3 mb-lg-0">
            <h3>Main Pages</h3>
            <ul className="footer-links">
              {mainSection?.length > 0 &&
                mainSection.map((item, index) => (
                  <li key={index}>
                    <a href={`${item.fieldContent}`}>{item.fieldName}</a>
                  </li>
                ))}
            </ul>
          </div>
          <div className="col-md-6 col-lg-3 mb-3 mb-lg-0">
            <h3>Areas</h3>
            <ul className="footer-links">

              {areaSection?.length > 0 &&
                areaSection.map((item, index) => (
                  <li key={index}>
                    <a href={`${item.fieldContent}`}>{item.fieldName}</a>
                  </li>
                ))}


            </ul>
          </div>
          <div className="col-md-6 col-lg-3 mb-3 mb-lg-0">
            <h3>Recommended</h3>
            <ul className="footer-links">

              {recommendedSection?.length > 0 &&
                recommendedSection?.map((item, index) => (
                  <li key={index}>
                    <a href={`${item.fieldContent}`}>{item.fieldName}</a>
                  </li>
                ))}


            </ul>
          </div>
          <div className="col-md-6 col-lg-3">
            <h3>Contact Details</h3>
            {contactSection?.length > 0 &&
              contactSection.map((item, index) => {

                if (item.fieldName === "Address") {
                  const addressLink = contactSection.find(x => x.fieldName === "AddressLink")?.fieldContent;

                  return (
                    <div className="flex-card" key={index}>
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/address-icon.svg"}
                            alt={"Address"}
                            className={"img-fluid"}
                            fetchPriority={"high"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <a href={addressLink} target="_blank">
                          {item.fieldContent}
                        </a>
                      </div>
                    </div>
                  )
                }
                if (item.fieldName === "Phone") {
                  return (
                    <div className="flex-card" key={index}>
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/phone-icon.svg"}
                            alt={"Phone"}
                            className={"img-fluid"}
                            fetchPriority={"high"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <a href={`tel:${item.fieldContent}`}>{item.fieldContent}</a>
                      </div>
                    </div>
                  )
                }
                if (item.fieldName === "Email") {
                  return (
                    <div className="flex-card" key={index}>
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/mail-icon.svg"}
                            alt={"Mail"}
                            className={"img-fluid"}
                            fetchPriority={"high"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <a href={`mailto:${item.fieldContent}`}>{item.fieldContent}</a>
                      </div>
                    </div>
                  )
                }
                if (item.fieldName === "WorkingDayFrom") {

                  const fromDay = item.fieldContent;
                  const toDay = contactSection.find(x => x.fieldName === "WorkingDayTo")?.fieldContent;
                  const fromTime = contactSection.find(x => x.fieldName === "WorkingTimeFrom")?.fieldContent;
                  const toTime = contactSection.find(x => x.fieldName === "WorkingTimeTo")?.fieldContent;

                  return (
                    <div className="flex-card" key={index}>
                      <div className="icon-block">
                        <span>
                          <CustomImageComponent
                            src={"/assets/img/time-icon.svg"}
                            alt={"Time"}
                            className={"img-fluid"}
                            fetchPriority={"high"}
                          />
                        </span>
                      </div>
                      <div className="text-block">
                        <h3>Working Hours</h3>
                        <p>{fromDay} - {toDay} </p>
                        <p className="footer-time-formate">{fromTime} - {toTime}</p>
                      </div>
                    </div>
                  )
                }

              })}




          </div>
        </div>
      </div>
      <hr />
      <div className="container">
        <div className="row align-items-center">
          <div className="col-md-6">
            <ul className="footer-links footer-links-bottom">
              <li>
                <a href={`/${countryPrefix}${language ? `/${language}` : ""}/privacy-policy`} target="_blank">Privacy Policy</a>
              </li>
              <li>
                <a href={`/${countryPrefix}${language ? `/${language}` : ""}/terms-conditions`} target="_blank">Terms & Conditions</a>
              </li>
              {/* <li>
                <a href={`${language}/faq`} target="_blank">FAQs</a>
              </li> */}

            </ul>
          </div>
          <div className="col-md-6 text-end">
            <p className="copy-text"> © Copyright {new Date().getFullYear()} - Connect Homes.</p>
          </div>
          {countryPrefix === 'ae' ? (
            <div className="col-md-6">
              <p className="copy-text">
                Cloud Connect Homes Real Estate L.L.C is a company registered in Dubai, United Arab Emirates under license No. 2527335 and regulated by the Real Estate Regulatory Agency under broker No. 51193
              </p>
            </div>
          ) : ''}

        </div>
      </div>
    </footer>
  );
};

export default Footer;
